import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import './styles/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(Toast, {
  transition: 'Vue-Toastification__fade',
  maxToasts: 20,
  newestOnTop: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
  showCloseButtonOnHover: true,
  toastClassName: 'app-toast',
  bodyClassName: 'app-toast__body',
  closeButtonClassName: 'app-toast__close',
})

// Mount app immediately - auth initialization happens in router guard
// This matches Vue 3 best practices and ensures router is ready
app.mount('#app')
